
	import { Component, Vue } from "vue-property-decorator";
	import { Getter, namespace } from "vuex-class";
	import { FilteredEvent } from "@/store/eventqueue/types";
	import { get } from "lodash";
	import { FeaturesList } from "@/store/types";

	const Eventqueue = namespace("eventqueue");

	@Component({
		components: {},
	})
	export default class PostProcessingQueue extends Vue {
		@Getter("getDbFederationEnabled") dbFederationEnabled: boolean;
		@Getter("getFeaturesList") featuresList: FeaturesList;
		
		@Eventqueue.Getter("getActiveEvents") private activeEvents!: FilteredEvent[];
		@Eventqueue.Mutation private setCountByType: ({ countType: string, count: number }) => void;

		private get isTypeColumnEnabled(): boolean {
			return get(this.featuresList, ["Alarms", "EventQueue", "ServerEventTitleInQueue"], false);
		}

		private get events(): FilteredEvent[] {
			if (this.activeEvents == null) {
				return null;
			}

			let filteredEvents = this.activeEvents.filter((q: FilteredEvent) => q.readyForPostProcessing);

			this.setCountByType({ countType: "postProcessing", count: filteredEvents.length });

            return filteredEvents;
		}

		private eventType(event: FilteredEvent): string {
			const title = event.serverEventTitle;
			return title == null ? "Unknown" : title.substring(0, Math.min(title.length, 50));
		}

		private get noEvents(): boolean {
			return typeof this.events == "undefined" || this.events == null || this.events.length == 0;
		}

		private postProcessAttempts(postProcessAttempts: number | null): number
		{
			if(!postProcessAttempts) {
				return 0;
			}

			return postProcessAttempts;
		}
	}
